// import {useContext} from "react";
// import QRCodeStyleViewContext from "../../QRCodeStyleViewContext";
import IconComponent from "./icons/IconComponent";
import CornersComponent from "./corners/CornersComponent";
import {Stack} from "@mantine/core";
import DotsComponent from "./dots/DotsComponent";

/**
 * Main view for QRCodeStyleView.
 * @QRCodeStyleViewTypes index
 * @author Kacper Faber
 * @since 0.1.9
*/
function IndexView() {
    // /**
    //  * QRCodeStyleViewContext
    //  * @author Kacper Faber
    //  * @since 0.1.9
    // */
    // const ctx = useContext(QRCodeStyleViewContext);

    return (
        <Stack gap="lg">
            <IconComponent/>

            <CornersComponent/>

            <DotsComponent/>
        </Stack>
    );
}

export default IndexView;